import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getCleanedUrlParams, showError } from '@utils';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import { marketingServices } from '@services';
import { LIMIT } from '@constants';
import { normalizeCampaigns } from './utils';

export const CAMPAIGNS_PAGE_SIZE = LIMIT;

export const useCampaignsOperations = (enableFetch = true) => {
  const router = useRouter();

  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || CAMPAIGNS_PAGE_SIZE;
  const order = router.query?.order;
  const orderBy = router.query?.orderBy;
  const token = router?.query?.token;

  const campaignsResponse = useQuery(
    [QUERY_KEYS.GET_CAMPAIGNS_KEY, { orderBy, order, page, pageSize }],
    () =>
      marketingServices.getCampaigns(
        getCleanedUrlParams({
          orderBy,
          order,
          page,
          pageSize: parseInt(pageSize, 10) || CAMPAIGNS_PAGE_SIZE,
        })
      ),
    { enabled: enableFetch, refetchOnMount: true }
  );

  const campaigns = normalizeCampaigns(campaignsResponse?.data?.data || []);

  useEffect(() => {
    if (campaignsResponse.isError) {
      showError(campaignsResponse?.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignsResponse.isError]);

  return {
    page,
    pageSize: parseInt(pageSize, 10) || CAMPAIGNS_PAGE_SIZE,
    total: campaignsResponse?.data?.meta?.total,
    loading: campaignsResponse?.isLoading,
    campaigns,
    hasErrors: campaignsResponse?.isError,
    errorMessage: campaignsResponse?.error,
    getCampaigns: campaignsResponse.refetch,
    token,
  };
};
